import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const CLAIMLINE_LOADING = 'CLAIMLINE_LOADING'
export const CLAIMLINE_SUCCESS = 'CLAIMLINE_SUCCESS'
export const CLAIMLINE_FAILED = 'CLAIMLINE_FAILED'

export const fetchClaimLines = (claimId) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/claims/${NgrxAuth.memberId}/ClaimLines/${claimId}`,
        prefix: 'CLAIMLINE',
        method: 'post',
        mock: false
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/claimLineActions.js